import React from 'react'

export const FileEdit = (props) => (
  <svg
    width='24'
    height='24'
    viewBox='0 0 24 24'
    fill={props.fill || 'none'}
    xmlns='http://www.w3.org/2000/svg'
  >
    <g clipPath='url(#clip0_34_973)'>
      <path
        d='M21 15.243V21.008C20.9997 21.2712 20.895 21.5235 20.7088 21.7095C20.5226 21.8955 20.2702 22 20.007 22H3.993C3.86168 21.9991 3.73182 21.9723 3.61085 21.9212C3.48987 21.8701 3.38015 21.7957 3.28794 21.7022C3.19573 21.6087 3.12284 21.4979 3.07344 21.3762C3.02403 21.2545 2.99908 21.1243 3 20.993V9H9C9.26522 9 9.51957 8.89464 9.70711 8.70711C9.89464 8.51957 10 8.26522 10 8V2H20.002C20.553 2 21 2.455 21 2.992V6.757L12.001 15.757L11.995 19.995L16.241 20.001L21 15.243ZM21.778 8.808L23.192 10.222L15.414 18L13.998 17.998L14 16.586L21.778 8.808ZM3 7L8 2.003V7H3Z'
        fill={props.fill || 'currentColor'}
      />
    </g>
    <defs>
      <clipPath id='clip0_34_973'>
        <rect width='24' height='24' fill='white' />
      </clipPath>
    </defs>
  </svg>
)
